import React from 'react'
import Breadcrum from '../Components/Breadcrum'

const WhishlistPage = () => {
  return (
    <div>
      <Breadcrum pageName={'Wishlist'}/>

      

    </div>
  )
}

export default WhishlistPage